import { CalendarSurfaceStore, createEmptySurfaceStore } from 'owa-calendar-surface-dategrid';
import { createStore } from 'satcheljs';

/* TODO: VSO 53878. We will be able to print SingleDayView with multiple days after the server work is complete. */
let surfaceStoreData: CalendarSurfaceStore = createEmptySurfaceStore();

export const getPrintSurfaceStore = createStore<CalendarSurfaceStore>(
    'calendarSurfacePrintStore',
    surfaceStoreData
);

const surfaceStore = getPrintSurfaceStore();
export default surfaceStore;
